import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { catalogRatioTypesGql } from '../catalogRatiosQueries';

export const useTypesData = (typesEffect: boolean) => {
    const [typesDataReset] = useResetStoreData({
        requestId: 'catalogRatioTypes',
    });

    useEffect(
        () => () => {
            typesDataReset(undefined);
        },
        [typesDataReset],
    );

    const [typesData, typesStatus] = useRequest({
        requestId: 'catalogRatioTypes',
        query: catalogRatioTypesGql,
        withEffect: typesEffect,
    });

    return useMemo(
        () => ({
            typesData: typesData?.catalogRatioTypes?.items ?? [],
            typesStatus,
        }),
        [typesData?.catalogRatioTypes?.items, typesStatus],
    );
};
